/* eslint-disable prettier/prettier */
import { compiledAppState } from 'data/app/compiled';
import { createContext } from 'react';
import {
  PatientOverviewDto,
  RewardListDto,
  PatientUsageReportDto,
  AccessRightDTO,
  DailySummaryDto,
  CurriculumProgressDTO,
  TreatmentProgressSummaryDto,
  PatientInfoDTO,
} from '@peartherapeutics/hylia-api-client';
import { ArStatusEnum } from 'data/app/dashboard-summary/patient-info';

/** Initial value for PatientDashboard context object.
 * Providing intial values facilitates unit testing (no additional context required)
 */
export const initialContextValue: IDashboardContextType = compiledAppState;

/** Context object for Patient Dashboard */
export const DashboardContext = createContext(initialContextValue);

export interface IDashboardContextType {
  // General: PatientDashboard
  patientId?: Nullable<string>;

  selectedAccessRight?: AccessRightDTO;
  setSelectedAccessRight: (f: AccessRightDTO) => void;

  selectedArStatus?: ArStatusEnum;
  selectedArId?: string;
  setSelectedArId: React.Dispatch<React.SetStateAction<string | undefined>>;

  // Cravings Tab
  dailySummaries?: DailySummaryDto[];
  setDailySummaries: (f: DailySummaryDto[]) => void;

  // Overview Tab
  overview?: PatientOverviewDto;
  setOverview: React.Dispatch<
    React.SetStateAction<PatientOverviewDto | undefined>
  >;

  // Rewards Tab
  rewardList?: RewardListDto;
  setRewardList: React.Dispatch<
    React.SetStateAction<RewardListDto | undefined>
  >;

  usageReport?: PatientUsageReportDto;
  setUsageReport: React.Dispatch<
    React.SetStateAction<PatientUsageReportDto | undefined>
  >;

  curriculumProgress?: CurriculumProgressDTO;
  setCurriculumProgress: React.Dispatch<
    React.SetStateAction<CurriculumProgressDTO | undefined>
  >;

  // Treatment Summary
  treatmentSummary?: TreatmentProgressSummaryDto;
  setTreatmentSummary: (summary: TreatmentProgressSummaryDto) => void;

  // Patient info
  patientInfo?: PatientInfoDTO;
  setPatientInfo: (summary: PatientInfoDTO) => void;
}
